var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1641 3.07812C17.4766 3.39062 17.75 3.97656 17.75 4.40625V14.875C17.75 15.9297 16.8906 16.75 15.875 16.75H12.75V18.625C12.75 19.6797 11.8906 20.5 10.875 20.5H2.125C1.07031 20.5 0.25 19.6797 0.25 18.625V6.125C0.25 5.10938 1.07031 4.25 2.125 4.25H5.25V2.375C5.25 1.35938 6.07031 0.5 7.125 0.5H13.8438C14.2734 0.5 14.8594 0.773438 15.1719 1.08594L17.1641 3.07812ZM10.6406 18.625C10.7578 18.625 10.875 18.5469 10.875 18.3906V16.75H7.125C6.07031 16.75 5.25 15.9297 5.25 14.875V6.125H2.35938C2.20312 6.125 2.125 6.24219 2.125 6.35938V18.3906C2.125 18.5469 2.20312 18.625 2.35938 18.625H10.6406ZM15.6406 14.875C15.7578 14.875 15.875 14.7969 15.875 14.6406V6.75H12.4375C11.8906 6.75 11.5 6.35938 11.5 5.8125V2.375H7.35938C7.20312 2.375 7.125 2.49219 7.125 2.60938V14.6406C7.125 14.7969 7.20312 14.875 7.35938 14.875H15.6406ZM15.875 4.875V4.52344C15.875 4.44531 15.8359 4.40625 15.7969 4.36719L13.8828 2.45312C13.8438 2.41406 13.8047 2.375 13.7266 2.375H13.375V4.875H15.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/copy2.500b2b1910974c00e309f627e5825081.svg";
export { ForwardRef as ReactComponent };